import { render, staticRenderFns } from "./ReportIndirectMaterial.vue?vue&type=template&id=f6b966c2&scoped=true&"
import script from "./ReportIndirectMaterial.vue?vue&type=script&lang=js&"
export * from "./ReportIndirectMaterial.vue?vue&type=script&lang=js&"
import style0 from "./ReportIndirectMaterial.vue?vue&type=style&index=0&id=f6b966c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b966c2",
  null
  
)

export default component.exports